var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.componentShow
    ? _c(
        "div",
        { staticClass: "md-custom-code federated" },
        [_c("MainComponent", { tag: "components" })],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }